// Copyright © 2021 Move Closer
import { AbstractTypeDriver } from './abstract';
import { RelatedType } from '../contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class GalleryDriver extends AbstractTypeDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = RelatedType.Gallery;
    }
    /**
     * @inheritDoc
     */
    resolve(id, record, config, driverResolver) {
        const description = super.resolve(id, record, config, driverResolver);
        return [
            ...description.items
        ];
    }
}
